<script setup>
import { cloneVNode, h, isVNode, useAttrs } from 'vue';

const props = defineProps({
  icon: { type: [String, Object, Function], required: true },
});

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();

const renderIcon = () => {
  if (!props.icon) return null;
  if (isVNode(props.icon)) return cloneVNode(props.icon, attrs);
  if (typeof props.icon === 'string') {
    return h('span', { ...attrs, class: [props.icon, attrs.class] });
  }
  return h(props.icon, attrs);
};
</script>

<template>
  <component :is="renderIcon" />
</template>
